import { DefaultHeaderFrSystm, DefaultHeaderToSystm } from "src/const";
import { API_PATH } from "src/const/api-urls";
import { FR_HEADER, TO_HEADER } from "src/const/const-from-env";
import { BaseResponse } from "src/interface";
import { IRequestInitPayment, IResponseCreatePaymentId } from "src/interface/typePay";
import { createCreDtTm, createMSGID } from "src/utils/helper";
import httpsService from "./httpsService";

export const getOderDetail = (
  data: {orderId: string},
  frSystm: string,
  toSystm: string,
) => {
  const msgId = createMSGID(frSystm)
  return httpsService.post<any, BaseResponse<any>>(API_PATH.GET_ORDER_DETAIL, data, {
    headers: {
      frSystm: frSystm,
      toSystm: toSystm,
      creDtTm: createCreDtTm(),
      msgId: msgId,
    },
    params: {
        msgId: msgId,
    },
  });
};